export default class Faq {
    static init(): void {
        const faqInitClasses = document.querySelectorAll<HTMLElement>('.js-faq-content');

        if (faqInitClasses.length > 0) {
            faqInitClasses.forEach((faqInitClass) => {
                const faqItems = faqInitClass.querySelectorAll<HTMLElement>('.faq-item');

                if (faqItems.length > 0) {
                    // Check and close all items on mobile
                    const checkMobileState = () => {
                        if (window.innerWidth <= 991) {
                            faqItems.forEach((item) => item.classList.remove('is-open'));
                        }
                    };

                    // Initialize on load
                    checkMobileState();

                    // Listen to resize event
                    window.addEventListener('resize', checkMobileState);

                    // Click handler
                    faqItems.forEach((item) => {
                        item.addEventListener('click', () => {
                            const isOpen = item.classList.contains('is-open');

                            faqItems.forEach((faq) => faq.classList.remove('is-open'));

                            if (!isOpen) {
                                item.classList.add('is-open');
                            }
                        });
                    });
                }
            });
        }
    }
}
